import React from 'react'
import PropTypes from 'prop-types'
import { SectionWrapper } from '../Section'
import H1 from '../H1'
import SuccessMessage from '../SuccessMessage'

function ExceptionMessage({ title, message, children }) {
  return (
    <SectionWrapper align='center'>
      {title && <H1>{title}</H1> }
      <SuccessMessage trailer>
        {message}
      </SuccessMessage>
      {children}
    </SectionWrapper>
  )
}

ExceptionMessage.propTypes = {
  title: PropTypes.node,
  message: PropTypes.node.isRequired,
  children: PropTypes.node
}

export default ExceptionMessage
